/** Extracts the bearer token from the authorization header. */
export const extractBearerToken = (
  authorizationHeaderValue: string | undefined,
): string | undefined => {
  if (authorizationHeaderValue == undefined) return undefined;
  if (authorizationHeaderValue.startsWith("Bearer ")) {
    return authorizationHeaderValue.substring(7);
  }
  return undefined;
};

/** Converts a token to a bearer token header value. */
export const toBearerToken = (token: string): string => {
  return `Bearer ${token}`;
};
